import React, { useEffect } from 'react'
import useSurveyLocale from '../../modules/locale/useSurveyLocale'
import style from './style.module.scss'
import { storeExtension } from './constants'

interface IIntroViewProps {
  onShown?: () => void
  store: string
  findability: boolean
  storeName?: string
}
const IntroShelfView = ({ onShown, store, findability, storeName }: IIntroViewProps) => {
  const { t, localeID } = useSurveyLocale()
  const STORE_KEY = store.slice(0, -1)
  const EXT = storeExtension(store, localeID)
  const STORE = storeName ? `${storeName}.${EXT}` : `${t('questions', 'ec', STORE_KEY, 'store')}.${EXT}`
  const CHECKOUT = t('questions', 'ec', STORE_KEY, 'checkout')

  useEffect(() => {
    onShown?.()
  }, [onShown])

  return (
    <div className={`${style.introShelfView}`} data-testid="SW-SH" aria-labelledby="sh-label">
      <span
        dangerouslySetInnerHTML={{
          __html: findability
            ? t<(store: string) => string>('questions', 'ec', 'introFindabilityBody')(STORE)
            : t<(store: string, checkout: string) => string>('questions', 'ec', 'introBody')(STORE, CHECKOUT)
        }}
      />
    </div>
  )
}

export default IntroShelfView
